import styled from "styled-components";

export const GerarBookFertResu = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;

    div.GerarBookFertResu__content {
        width: 100%;
        display: flex;
        gap: 15px;
    }

    div.GerarBookFertResu__footer {
        width: 100%;
        height: 40px;
        border-top: thin solid var(--border-color);
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }
`;